import { ComponentProps, FC } from 'react';
import { MediaControlBar } from 'media-chrome/react';
import styleToCss from 'style-object-to-css-string';
import styled from 'styled-components';
import { allProps, Box } from '@altermaind/web/ui';

type Props = ComponentProps<typeof Box> & {};

export const VideoPlayerMainContainer = styled(Box)<Props>(
  () => `
  ${styleToCss({
    width: '90vw',
    maxWidth: 'calc(90vh * 16 / 9)',
    aspectRatio: '16/9',
    maxHeight: '90vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  })}

  &:hover media-control-bar, 
  &:focus-within media-control-bar {
      ${styleToCss({
        opacity: 1,
        pointerEvents: 'auto',
        transform: 'translateY(0)',
      })}
    }
  
`,
  allProps,
) as FC<Props>;

type VideoPlayerPanelControlsOverlayProps = ComponentProps<typeof MediaControlBar> & {};
export const VideoPlayerPanelControlsOverlay = styled(
  MediaControlBar,
)<VideoPlayerPanelControlsOverlayProps>(
  () => `
  ${styleToCss({
    position: 'absolute',
    inset: 0,
    width: '100%',
    height: '100%',
    aspectRatio: '16/9',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    /* overlay “alto e largo 100%” */
    background: `linear-gradient(to bottom, rgba(0,0,0,0.55), rgba(0,0,0,0) 35%),
              linear-gradient(to top, rgba(0,0,0,0.65), rgba(0,0,0,0.5) 45%)`,
    /* hidden by default */
    opacity: 0,
    pointerEvents: 'none',
    transform: 'translateY(6px)',
    transition: 'opacity 180ms ease, transform 180ms ease',
  })}

  &:hover media-control-bar, 
  &:focus-within media-control-bar {
      ${styleToCss({
        opacity: 1,
        pointerEvents: 'auto',
        transform: 'translateY(0)',
      })}
    }
  
`,
  allProps,
) as FC<Props>;
